
import Vue from 'vue'
import vConfirmForm from './ConfirmForm.vue'
let modalFactory = null

export default {
  setModalFactory: function (ref) {
    modalFactory = ref
  },
  isModal: function () {
    return modalFactory && modalFactory.isModal()
  },
  register: function (tag, component) {
    Vue.component(tag, component)
  },
  modal: function (comp) {
    if (modalFactory) {
      modalFactory.open(comp)
    } else {
      console.log('dialogs.modal', 'Error Modal Factory was not defined')
    }
  },
  confirm: function (self, title, question, cb, cancelCb) {
    const onOk = () => cb(self)
    const onCancel = () => cancelCb ? cancelCb(self) : {}
    this.register('v-confirm-form', vConfirmForm)
    var fullscreen = false
    var comp = { template: `
      <v-confirm-form v-on:close="$emit('close')"
      v-on:ok="okCb"
      v-on:cancel="cancelCb"
      :fullscreen="fullscreen"
      :title="title"
      :question="question"
      ></v-confirm-form>
      `,
      data () {
        return {
          fullscreen: fullscreen,
          okCb: onOk,
          cancelCb: onCancel,
          title: title,
          question: question
        }
      }
    }
    this.modal(comp)
  },
  message: function (self, title, question) {
    const okCb = () => {}
    this.register('v-confirm-form', vConfirmForm)
    var fullscreen = false
    var comp = { template: `
      <v-confirm-form v-on:close="$emit('close')"
      v-on:ok="okCb"
      :fullscreen="fullscreen"
      :title="title"
      :question="question"
      noCancel
      ></v-confirm-form>
      `,
      data () {
        return {
          fullscreen: fullscreen,
          okCb: okCb,
          title: title,
          question: question
        }
      }
    }
    this.modal(comp)
  }
}



// WEBPACK FOOTER //
// ./src/components/common/dialogs.js